import axios from 'axios';


import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';
import {typesReview} from '../svtypes/reviewTypes'
const _ = require('lodash')





const headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


  export function priceAndTexNow(rqValues,hdr, relUrl){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svpriceAndTexBegin())
        const urlNewCustomer = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spacePriceAndTaxReviewMultiEntity`
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spacePriceAndTaxReviewMultiEntityMYRESERVATIONSV`
        let url  = urlNewCustomer
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            url = urlMyReservation
        }
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const svurl = relUrl ? `${SV_SOJ_ORCMOCK_ADDRESS}/${relUrl}` :url
          const svhdr = hdr ? hdr: headers 
        
        axios.post(svurl, rqValues, {headers:svhdr})
        .then(
            r => {
                let comData = {
                    "my_data_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_price_confirmation = r.data
                    

                   
                    dispatch(getPriceAndTexSuccess(comData))
                }
                else {
                    comData.my_data_price_confirmation.status = "FAILED"
                    comData.my_data_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}

export function priceAndTexNowSecure(rqValues, svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow LATEST**from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svpriceAndTexBegin())
        const urlNewCustomer = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spacePriceAndTaxReviewMultiEntity`
        /*sva */
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spacePriceAndTaxReviewMultiEntityMYRESERVATIONSVSecure`
       /*
        const urlMyReservation = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
        rqValues = {"id":90}
        */
        /*svae*/
        let url  = urlNewCustomer
        if(rqValues.meta &&  (rqValues.meta.addressId > 0) && (rqValues.meta.cardId > 0) && (rqValues.meta.customerId > 0)){
            url = urlMyReservation
        }
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
          const authtoken = `Bearer ${svtv}`
          const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
       
        
        axios.post(url, rqValues, {headers:svheaders})
        .then(
            r => {
                let comData = {
                    "my_data_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                /*sva */
                let crudsuccessob ={
                    "timestamp": "2015-08-23T02:27:18.038+0000",
                    "status": 200,
                    "error": "",
                    "message": "Create Done ",
                    "path": "/kk/svaddressDetailPost"
                }
                comData.crudsuccessob = crudsuccessob

                /*svae */
                if(r.data){
                   
                    const ob = r.data
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getPriceAndTexError(eeb))
                    }else{
                        comData.my_data_price_confirmation = r.data
                        comData.crudsuccessob.message = "Confirmation Number:" +  comData.my_data_price_confirmation.confirmationNumber
                    

                   
                        dispatch(getPriceAndTexSuccess(comData))
             
                    }
                   
                          }
                else {
                    comData.my_data_price_confirmation.status = "FAILED"
                    comData.my_data_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexError(comData))
                }
            }
        ).catch(
            
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}
export function priceAndTexNowSingle(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(svpriceAndTexBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spacePriceAndTaxReview`
        /*
       // const url = 'http://localhost:8080/essearch/spacePriceAndTaxReview'
        
       const body = {
            card : {
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            },
            traveller: {
                "id": "addLeft_step",
                "gene": "addLeft_step",
                "dcountry": "China",
                "privateparking":false,
                "rentcar":false,
                "bookTaxi":false,
                "needFlight":false,
                "arrivalTimeZone":"tz_pst",
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "address": "Glen",
                "city": "Glen",
                "state": "Glen",
                "zip": "12110",
                "country": "Glen",
                "isdcode": "+1",
                "phone": "Glen",
                "bookingAgentType": "self",
                "traveType": "Personal",
                "specialRequests": "Wheel chair and Senior Citizen",
                "gname": "Glen",
                "gemail": "Glen@yahoo.com",
                "card": "1234-1234--1234--1234",
                "cvv": "Glen",
                "mmexp": "04",
                "yyyyexp": "2028"
            }
          } 
          */
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                let comData = {
                    "my_data_price_confirmation" : {

                        "status":"OK",
                        "confirmationNumber":"UU12345",
                        "chekinDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_price_confirmation = r.data
                    

                   
                    dispatch(getPriceAndTexSuccess(comData))
                }
                else {
                    comData.my_data_price_confirmation.status = "FAILED"
                    comData.my_data_price_confirmation.confirmationNumber = "XXX"
                    comData.my_data_price_confirmation.chekinDate = "Jan 3027"

                    dispatch(getPriceAndTexSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getPriceAndTexError(e))
        )
    }

}

export const svpriceAndTexBegin = () => dispatch => {
    dispatch({
        type:typesReview.GET_PRICEANDTAX_BEGIN
        
    })
}
export const svLoadReviewBegin = () => dispatch => {
    dispatch({
        type:'GET_REVIEW_BEGIN'
        
    })
}


export const getPriceAndTexSuccess = (data) => dispatch => {
    dispatch({
        type: typesReview.GET_PRICEANDTAX_SUCCESS,
        payload: data
    })
}
export const saveTravellerReviewSuccess = (dataOb) => dispatch => {
    dispatch({
        type: 'SAVETRAVELLER_REVIEW_SUCCESS',
        payload: dataOb
    })
}


export const geLoadAddressDataDBCustSuccess = (data) => dispatch => {
    dispatch({
        id:-1,
        type:typesReview.CREATE_ADDRESS || 'MYRESERVATIONS_PRIMARY_ADDRESS',
        payload: data
    })
}

export const geLoadReviewSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_REVIEW_SUCCESS',
        payload: data
    })
}

export const geLoadReviewNyReservationCustSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_REVIEW_MYRESERVATION_SV_SUCCESS',
        payload: data
    })
}




export const getPriceAndTexError = (e) =>dispatch => {
    console.log('pricetax error')
    console.log(e)
    dispatch({
        type:typesReview.GET_PRICEANDTAX_ERROR,
        /*sva  error:e*/
        payload:e
        /*svae*/
    })
}

export const getLoadReviewError = (e) =>dispatch => {
    dispatch({
        type:'GET_REVIEW_ERROR',
        error:e
    })
}

export const svLoadReviewdetReset = (data) => dispatch => {
    data = data || {"orderId": -1,
    "status":"OK",
        "confirmationNumber":"UU12345",
        "chekinDate":"Jan 3027"
}
    dispatch({
        type: "RESET_PRICEANDTAX_INIT",
        payload: data
    })
}



/*

export const getBookError = (e) =>dispatch => {
    dispatch({
        type:typesBook.GET_BOOK_ERROR,
        error:e
    })
}
*/
export function loadReviewSingleNoPriceNow(rqValuesSpaceId){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For priceAndTexNow from Microservices DB swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(svLoadReviewBegin())
        /*
        const url = 'http://localhost:8080/essearch/spaceLoadReview'
        const body = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }
          */
          const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spaceLoadReview`
          const body = {
              "query": {
                  "bool": {
                      "must": [
                          {
                              "match": {
                                  "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                              }
                          }
                      ]
                  }
              }
           }
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r.data){

                  
                   
                    if(r.data.hits.hits.length>0){
                        const ar = r.data.hits.hits
                        let recs_with_duplicate_ar = []
                        let space_rec = {}
                       
                        var item , ob, sod, upperOb
                        
                        ar.forEach(a_rec => {
                            item = {}
                           
                            upperOb = a_rec['_source']
                            ob =lowercaseKeys(upperOb)
    
                            sod =  _.clone(ob)
    
                            
    
                            recs_with_duplicate_ar.push(sod)
                        });
                        space_rec = recs_with_duplicate_ar[0]
                        my_data_review_tp.booking = space_rec
                        let soj = space_rec
                        let svr_location = {
                            "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                            "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                            "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                            "county": soj['county'] ? soj['county'] : "albanyt",
                            "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                            "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                            "country": soj['country_name'] ? soj['country_name'] : "usa",
                           "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                           "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                            
                           "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                           "state":soj['state'] ? soj['state'] : "NY"

                        }

                      let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                      my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                      let amenity_name = [
                        "300 feet elevator",
                        "air conditioning",
                        "private bathroom"
                    ]
                      my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name

                       
                    }
                    else {
                       console.log('getting error * review Load Action')
                       
                    }

                    const comData = {my_data_review:my_data_review_tp}
                    

                   
                    dispatch(geLoadReviewSuccess(comData))
                }
                else {
                    const comData = {my_data_review:my_data_review_tp}
                    dispatch(geLoadReviewSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
    }

}
/***ne cal start****/

export function loadReviewNow(rqValuesSpaceId){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(svLoadReviewBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spaceLoadReview`
        const body = {
            "query": {
              "match": {
                "SPACEKEY.keyword": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }

        const bodyPriceGet = {
            "query": {
              "match": {
                "SPACEKEY.keyword": "10000416@4@F@10@10@20251124@7@Y@SVR"
              }
            }
          }
        const bodyBad = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                            }
                        }
                    ]
                }
            }
         }

        
          
        
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourPriceView`

        axios.all([
            axios.post(url, body, {headers:headers}),
            axios.post(urlSpacePrice,bodyPriceGet, {headers:headers})
        ], {
  timeout: 7000
})
        .then(
            axios.spread((r,r2)=>{
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r.data){

                   
                    
                     if(r.data.hits.hits.length>0){
                         const ar = r.data.hits.hits
                         let recs_with_duplicate_ar = []
                         let space_rec = {}
                        
                         var item , ob, sod, upperOb
                         
                         ar.forEach(a_rec => {
                             item = {}
                            
                             upperOb = a_rec['_source']
                             ob =lowercaseKeys(upperOb)
     
                             sod =  _.clone(ob)
     
                             
     
                             recs_with_duplicate_ar.push(sod)
                         });
                         space_rec = recs_with_duplicate_ar[0]
                         my_data_review_tp.booking = space_rec
                         let soj = space_rec
                         let svr_location = {
                             "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                             "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                             "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                             "county": soj['county'] ? soj['county'] : "albanyt",
                             "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                             "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                             "country": soj['country_name'] ? soj['country_name'] : "usa",
                            "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                            "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                             
                            "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                            "state":soj['state'] ? soj['state'] : "NY"
 
                         }
 
                       let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                       my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                       let amenity_name = [
                         "300 feet elevator",
                         "air conditioning",
                         "private bathroom"
                     ]
                       my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name
 
                        
                     }
                     else {
                        console.log('getting error * review Load Action')
                        
                     }
 
                     const comData = {my_data_review:my_data_review_tp}
                     
                     if( r2.data && r2.data.hits  && r2.data.hits.hits.length>0){
                        let ob2,sod2, upperOb2
                        const ar2 = r2.data.hits.hits
                        const a_rec2 = ar2[0] || {}
                        upperOb2 = a_rec2['_source']
                        ob2 =lowercaseKeys(upperOb2)

                        sod2 =  _.clone(ob2)
                        /*svsept6 start*/
                        /*
                        let cost = sod2.productcostamount || 100
                        let totaltax = 0
                       
                        let currencycode='$', taxPercent = 6,citytaxPercent=6.5, maintax =0, citytax=0
                        */
                        /*svsept6 end*/
                        let cost = sod2['PRODUCT_COST_AMOUNT'] || 100
                        console.log('++++++sept6****** START')
                        console.log(cost)
                        let taxPercent = sod2['TAX_PERCENT'] ||  6
                        let citytaxPercent = sod2['CITYTAX_PERCENT'] ||  6.5
                        let totaltax = 0
                        
                        let currencycode='$', maintax =0, citytax=0
                       
                        maintax = cost * taxPercent /100
                        maintax = Number(maintax.toFixed(2))
                        
                        citytax = cost * citytaxPercent /100
                        citytax = citytax.toFixed(2)
                        citytax =Number(citytax)
                        totaltax = maintax + citytax
                        totaltax = totaltax.toFixed(2)
                        totaltax = Number(totaltax)
                        console.log('++++++sept6******')
                        let fullPriceWithtax = totaltax + cost
                        /*sv sept6  start*/
                        if(sod2["CURRENCY_CODE"]== 'DL'){
                            currencycode = '$'
                        }else{
                            currencycode =  '$'
                        }
                        if(sod2["CURRENCY_CODE"]== 'USD'){
                            currencycode = '$'
                        }else{
                            currencycode =  '$'
                        }
                         /*sv sept6  end*/
                        let priceOb= {

                            "total": currencycode+fullPriceWithtax,
                            "depositValue":"0",
                            "depositName":"Damage Deposit (Fully refundable)",
                            "currency": "usd",
                            "tax": {
                               
                                "taxTotal": currencycode+totaltax,
                                "maintax":  currencycode+maintax,
                                "citytax":  currencycode+citytax,
                    
                                "taxPercent": "6",
                                "citytaxPercent": "6.5"
                            }
                        }

                        console.log(priceOb)
                        console.log('++++++sept6******  END')
                        my_data_review_tp.price = priceOb
                        
                        
                       
                    }
                    
                     dispatch(geLoadReviewSuccess(comData))
                 }
                 else {
                     const comData = {my_data_review:my_data_review_tp}
                     dispatch(geLoadReviewSuccess(comData))
                 }

                   
                }
            )
            /*svend*/
          
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
    }

}



export const loadCardData=(data)=>{
    console.log('action loadCardData')
    console.log(data)
    let my_data_card = data

    if(my_data_card.cardId && my_data_card.cardId > 0){
        my_data_card.id =  my_data_card.cardId
    }else{
        my_data_card.id = -12
    }

    if(my_data_card.cardNumber && my_data_card.cardNumber.length > 0){
        my_data_card.card =  my_data_card.cardNumber
    }else{
        my_data_card.cardNumber = "7777777777777777"
    }
    if(my_data_card.cardCvv && my_data_card.cardCvv.length > 0){
        my_data_card.cvv =  my_data_card.cardCvv
    }else{
        my_data_card.cvv = "777"
    }

    if(my_data_card.cardExpMonth && my_data_card.cardExpMonth.length > 0){
        my_data_card.mmexp =  my_data_card.cardExpMonth
    }else{
        my_data_card.mmexp = "07"
    }

    if(my_data_card.cardExpYear && my_data_card.cardExpYear.length > 0){
        my_data_card.yyyyexp =  my_data_card.cardExpYear
    }else{
        my_data_card.yyyyexp = "77"
    }


    let comData = {my_data_card : my_data_card}
    var action = {
       id:-1,
        type: 'MYRESERVATIONS_PRIMARY_CARD',
        payload:comData
    }
    console.log(action)
    return action

}

/*loadReviewNowMyReservationForCustId  **/

export const loadAddressData=(data)=>{
    console.log('action CREATE_STEP')
    console.log('Oct5 Payment detail calling with data', data)
    console.log(data)
    let my_data_address = data
    if(my_data_address.zipcode && my_data_address.zipcode.length > 0){
        my_data_address.zip =  my_data_address.zipcode
    }else{
        my_data_address.zip = "77777"
    }

    if(my_data_address.addressId && my_data_address.addressId > 0){
        my_data_address.id =  my_data_address.addressId
    }else{
        my_data_address.id = -12
    }
    

    let comData = {my_data_address : my_data_address}
    console.log('Oct5 Payment detail updating adressdate for form with data', comData)
   
    var action = {
       id:-1,
        type:typesReview.CREATE_ADDRESS || 'MYRESERVATIONS_PRIMARY_ADDRESS',
        payload:comData
    }
    console.log(action)
    return action

}
/*
export const loadAddressDataDB=(custProfile)=>{
    console.log('action CREATE_STEP')
   
    const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDetail`
    let nameQParam = -1
   
   

    
    const body = {
        "id": (custProfile && custProfile.addressId? custProfile.addressId:-1)
       }

       axios.post(url, body, {headers:headers})
       .then(
           r => {
            let comData = {my_data_address : null}
               if( r.data ){
                   const ob = r.data
                 

                   let my_data_address = ob
                    
                    comData.my_data_address = my_data_address
                   
                    console.log(action)
                   
                    dispatch(geLoadAddressDataDBCustSuccess(comData))
                   

               }
               else {
                  
                   dispatch(geLoadAddressDataDBCustSuccess(comData))
               }
           }
       ).catch(
        e=>dispatch(getLoadReviewError(e))
       )

    

}
*/
export function loadReviewNowMyReservationForCustId(rqValuesSpaceId, custProfile){

    console.log('%%%%%%%%%%%%%%%sv++++REST API For sojDetailsAndImagesSV _doc swith sae key :' + rqValuesSpaceId)
    return dispatch => {
        dispatch(svLoadReviewBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/spaceLoadReview`
        const body = {
            "query": {
              "match": {
                "SPACEKEY.keyword": (rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
              }
            }
          }

        const bodyBad = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword":(rqValuesSpaceId? rqValuesSpaceId:"DN11@4@F@10@10@20231124@7@Y@EVR") 
                            }
                        }
                    ]
                }
            }
         }

        
          
        
        const urlSpacePrice = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/sojourPriceView`
        const bodyPriceGet = {
            "query": {
              "match": {
                "SPACEKEY.keyword": "10000416@4@F@10@10@20251124@7@Y@SVR"
              }
            }
          }
//localhost:8086/account/addressListByCustomerIdView
        const urlAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListByCustomerIdView`
        const bodyAddressList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
       
        const urlCardList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/cardListByCustomerIdView`
        const bodyCardList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
        if(custProfile && (custProfile.customerId > 0)){
            let customerId = custProfile.customerId
            bodyAddressList.docId.push("" + customerId)
            bodyCardList.docId.push("" + customerId)
        }else{
            console.log('custProfile + error by UI')
        }
       
        //localhost:8086/account/cardListByCustomerIdView
        axios.all([
            axios.post(url, body, {headers:headers}),
            axios.post(urlSpacePrice,bodyPriceGet, {headers:headers}),
            axios.post(urlAddressList, bodyAddressList, {headers:headers}),
            axios.post(urlCardList, bodyCardList, {headers:headers}),
        ], {
  timeout: 7000
})
        .then(
            axios.spread((r,r2, r3,r4)=>{
                let  my_data_review_tp = {
                    "Request": {
                        "checkin": "OK",
                        "stay": "6",
                        "stayInit": "nights",
                        "checkout": "UU12345",
                        "checkinTime": "Sat, Sept 9, 3027",
                        "checkinTimePrefix": "From 3:00 PM",
                        "checkoutTimePrefix": "Until 11:00 AM",
                        "checkoutTime": "Sat, Sept 16, 3027"
                    },
                    "spaceDet": {
                    
                        "space_details": "Queen Room with Two Queen Beds",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "cancellation": "Free cancellation before December 9, 2024 ",
                        "guests": "2 adults ",
                        "cleaniness_score" : "7.7",
                        "non_smoking":true,
                
                        "space_amenity_name": [
                            "300 feet elevator",
                            "air conditioning",
                            "private bathroom"
                        ]
                       
                       
                    },
                    "booking": {
                        "resort_name": "Cambria Hotel Orlando Airport",
                        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                        "stayDet": "6 nights",
                        "num_reviews": 101,
                        "amenity_name": [
                            "HotTub",
                            "Spa",
                            "Swimming pool",
                            "Laundry"
                        ],
                        "num_reviews_label": "Good, ",
                        "rating_detail":" Excellebt, 9.1",
                        "num_reviews_detail": "Good, 101 reviews"
                       
                    },
                    "price": {
                        "total": "$923",
                        "depositValue":"$200.26",
                        "depositName":"Damage Deposit (Fully refundable)",
                        "currency": "usd",
                        "tax": {
                           
                            "taxTotal": "$102.34",
                            "maintax": "$49.08",
                            "citytax": "$53.26",
                
                            "taxPercent": "6",
                            "citytaxPercent": "6.5"
                        }
                    },
                    "id": "addLeft_step",
                    "gene": "addLeft_step",
                    "dcountry": "China",
                    "privateparking":false,
                    "rentcar":false,
                    "bookTaxi":false,
                    "needFlight":false,
                    "arrivalTimeZone":"tz_pst",
                    "fname": "John",
                    "lname": "Glen",
                    "email": "john123@yahoo.com",
                    "address": "Glen",
                    "city": "Glen",
                    "state": "Glen",
                    "zip": "12110",
                    "country": "Glen",
                    "isdcode": "+1",
                    "phone": "Glen",
                    "bookingAgentType": "self",
                    "traveType": "Personal",
                    "specialRequests": "Wheel chair and Senior Citizen",
                    "gname": "Glen",
                    "gemail": "Glen@yahoo.com",
                    "card": "1234-1234--1234--1234",
                    "cvv": "Glen",
                    "mmexp": "04",
                    "yyyyexp": "2028"
                }
                if(r.data){

                   
                    
                     if(r.data.hits.hits.length>0){
                         const ar = r.data.hits.hits
                         let recs_with_duplicate_ar = []
                         let space_rec = {}
                        
                         var item , ob, sod, upperOb
                         
                         ar.forEach(a_rec => {
                             item = {}
                            
                             upperOb = a_rec['_source']
                             ob =lowercaseKeys(upperOb)
     
                             sod =  _.clone(ob)
     
                             
     
                             recs_with_duplicate_ar.push(sod)
                         });
                         space_rec = recs_with_duplicate_ar[0]
                         my_data_review_tp.booking = space_rec
                         let soj = space_rec
                         let svr_location = {
                             "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                             "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                             "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                             "county": soj['county'] ? soj['county'] : "albanyt",
                             "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                             "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                             "country": soj['country_name'] ? soj['country_name'] : "usa",
                            "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                            "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                             
                            "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                            "state":soj['state'] ? soj['state'] : "NY"
 
                         }
 
                       let propertyAddressInfo = `${svr_location.address_line1}, ${svr_location.county}, ${svr_location.postalcode} , ${svr_location.country} `  
                       my_data_review_tp.spaceDet.propertyAddress = propertyAddressInfo
                       let amenity_name = [
                         "300 feet elevator",
                         "air conditioning",
                         "private bathroom"
                     ]
                       my_data_review_tp.spaceDet.space_amenity_name = soj.en_activity_name_lvl?  soj.en_activity_name_lvl : amenity_name
 
                        
                     }
                     else {
                        console.log('getting error * review Load Action')
                        
                     }
 
                     const comData = {my_data_review:my_data_review_tp, my_data_address:null, my_data_card:null}
                     
                     if( r2.data && r2.data.hits  && r2.data.hits.hits.length>0){
                        let ob2,sod2, upperOb2
                        const ar2 = r2.data.hits.hits
                        const a_rec2 = ar2[0] || {}
                        upperOb2 = a_rec2['_source']
                        //ob2 =lowercaseKeys(upperOb2)
                        ob2 = upperOb2

                        sod2 =  _.clone(ob2)

                        let cost = sod2['PRODUCT_COST_AMOUNT'] || 100
                        console.log('++++++sept6****** START')
                        console.log(cost)
                        let taxPercent = sod2['TAX_PERCENT'] ||  6
                        let citytaxPercent = sod2['CITYTAX_PERCENT'] ||  6.5

                        let currencycode='$',  maintax =0, citytax=0
                        let totaltax = 0
                         /*sv sept6  start gt*/
                         if(sod2["CURRENCY_CODE"]== 'DL'){
                            currencycode = '$'
                        
                         }else if(sod2["CURRENCY_CODE"]== 'USD'){
                            currencycode = '$'
                        }else{
                            currencycode =  '$'
                        }
                         /*sv sept6  end*/
                        /*
                        let cost = sod2.productcostamount || 100
                        let totaltax = 0
                       
                        let currencycode='$', taxPercent = 6,citytaxPercent=6.5, maintax =0, citytax=0
                        */
                        maintax = cost * (taxPercent /100)
                        console.log('maintax 1 ',maintax)
                        maintax = Number(maintax.toFixed(2))
                        console.log('maintax 2 ',maintax)
                        
                        citytax = cost * (citytaxPercent /100)
                        citytax = citytax.toFixed(2)
                        console.log('**SEPT-7')
                        console.log(citytax)
                        console.log('citytax 1 ',citytax)
                        citytax =Number(citytax)
                        console.log('citytax 2 ',citytax)
                        totaltax = maintax + citytax
                        console.log('totaltax 1 ',totaltax)
                        totaltax = totaltax.toFixed(2)
                        totaltax = Number(totaltax)

                        let fullPriceWithtax = totaltax + cost

                        if(sod2.currencycode == 'DL'){
                            currencycode = '$'
                        }else{
                            currencycode = sod2.currencycode
                        }
                        let priceOb= {

                            "total": `${fullPriceWithtax}`,
                            "depositValue":"0",
                            "depositName":"Damage Deposit (Fully refundable)",
                            "currency": "$",
                            "tax": {
                               
                                "taxTotal": `${totaltax}`,
                                "maintax":  `${maintax}`,
                                "citytax":  `${citytax}`,
                    
                                "taxPercent": `${taxPercent}`,
                                "citytaxPercent":`${citytaxPercent}`
                            }
                        }

                        console.log(priceOb)
                        console.log('**SEPT-7 end****************' )
                        my_data_review_tp.price = priceOb
                        
                        
                       
                    }
                    let custProfileClone = {
                        customerId: -11
                    }
                    if( r3.data  && r3.data.length>0){

                        

                        let ob3,sod3
                        const ar3 = r3.data 
                        const a_rec3 = ar3[0] || {}
                        ob3 = a_rec3
                        let my_data_address = ob3
                    
                        comData.my_data_address = my_data_address

                        sod3 =  _.clone(ob3)

                        my_data_review_tp.email = sod3.email
                        my_data_review_tp.addressType =sod3.addressType	? sod3.addressType :'B'
                        my_data_review_tp.fname = sod3.fname
                        my_data_review_tp.lname = sod3.lname
                        my_data_review_tp.addressId = sod3.addressId
                        my_data_review_tp.phone = sod3.phone
                        my_data_review_tp.email = sod3.email
                        my_data_review_tp.login = sod3.login
                        my_data_review_tp.city = sod3.city
                        my_data_review_tp.country = sod3.country
                        my_data_review_tp.state = sod3.state
                        my_data_review_tp.address = (sod3.address ?  sod3.address :"No address in DB")
                        my_data_review_tp.zip = sod3.zipcode
                        my_data_review_tp.isdcode = sod3.isdcode
                        my_data_review_tp.dcountry = sod3.country
                        if(sod3.customerId > 0){
                            custProfileClone.customerId = sod3.customerId
                            
                            
                        }
                        if(sod3.addressId > 0){
                            custProfileClone.addressId = sod3.addressId

                        }

                       


                    }


                    
                    comData.custProfile = custProfileClone
                    console.log('%%%sv*** svreviewaction comdata with custProfile froms db start')
                    console.log(custProfile)

                    if( r4.data  && r4.data.length>0){

                        

                        let ob4,sod4
                        const ar4 = r4.data 
                        const a_rec4 = ar4[0] || {}
                        ob4 = a_rec4
                        let my_data_card = ob4
                        if(my_data_card.cardId && my_data_card.cardId > 0){
                            my_data_card.id =  my_data_card.cardId
                        }else{
                            my_data_card.id = -12
                        }
                        if(my_data_card.cardNumber && my_data_card.cardNumber.length > 0){
                            my_data_card.card =  my_data_card.cardNumber
                        }else{
                            my_data_card.cardNumber = "7777777777777777"
                        }
                        if(my_data_card.cardCvv && my_data_card.cardCvv.length > 0){
                            my_data_card.cvv =  my_data_card.cardCvv
                        }else{
                            my_data_card.cvv = "777"
                        }
                    
                        if(my_data_card.cardExpMonth && my_data_card.cardExpMonth.length > 0){
                            my_data_card.mmexp =  my_data_card.cardExpMonth
                        }else{
                            my_data_card.mmexp = "07"
                        }
                    
                        if(my_data_card.cardExpYear && my_data_card.cardExpYear.length > 0){
                            my_data_card.yyyyexp =  my_data_card.cardExpYear
                        }else{
                            my_data_card.yyyyexp = "77"
                        }
                    
                    
                        comData.my_data_card = my_data_card
                    }
                    console.log(comData)
                    console.log('%%%sv*** svreviewaction comdata with custProfile froms db end')
                     dispatch(geLoadReviewNyReservationCustSuccess(comData))
                 }
                 else {
                     const comData = {my_data_review:my_data_review_tp}
                     comData.custProfile =null
                     dispatch(geLoadReviewNyReservationCustSuccess(comData))
                 }

                   
                }
            )
            /*svend*/
          
        ).catch(
            e=>dispatch(getLoadReviewError(e))
        )
    }

}